import { Button } from "./ui/Button";

export const CustomCTA = ({ question }) => {
  return <div>
    <div style={{ marginBottom: '8px', marginTop: '8px' }}>
      <span style={{ fontSize: 'medium' }}>{ question.title }</span>
    </div>
    <div>
      <span>Du behöver en prenumeration för att svara på denna fråga och se resultatet.</span>
      <Button
        href={window.mentoCustomCtaUrl}
        text={'Prenumerera'}
      ></Button>
    </div>
  </div>;
}